/*
 * Copyright (c) 2026 Ambits Technologies LLC. All rights reserved.
 *
 * This source code is the proprietary and confidential property of
 * Ambits Technologies LLC. Unauthorized copying, modification, distribution,
 * or use of this software, via any medium, is strictly prohibited.
 *
 * MyAmbits - AI-Powered Location Safety & Social Platform
 * https://myambits.com
 */

import type { SOSTriggerMethod } from "@/types/safecircle";

type Listener = (method: SOSTriggerMethod) => void;

const listeners = new Set<Listener>();

/**
 * Lightweight pub-sub used to route SOS triggers from scattered surfaces
 * (existing `SOSButton`, shake listener, volume-button plugin, deviation
 * escalation) to the single `<SOSTrigger>` that owns the state machine.
 *
 * Kept as a plain module — no React context — because publishers like
 * global event handlers and headless utilities should not require being
 * mounted inside the provider tree.
 */
export const sosTriggerBus = {
  fire(method: SOSTriggerMethod) {
    for (const l of listeners) l(method);
  },
  subscribe(l: Listener): () => void {
    listeners.add(l);
    return () => listeners.delete(l);
  },
};
